import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_CONFIG } from '@qapline/config';
import { Button, LogoutIcon, Modal, Typography } from '@qapline/ui';

import styles from './LogoutButton.module.scss';

export const LogoutButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOpenModal = () => {
        setIsOpen(true);
    };
    const handleCloseModal = () => {
        setIsOpen(false);
    };
    const handleLogout = () => {
        navigate(DEFAULT_CONFIG.routes.auth.logout);
    };

    return (
        <>
            <Button size="medium" variant="fab" color="transparent-light" onClick={handleOpenModal}>
                <LogoutIcon width={24} height={24} color="inherit" />
            </Button>
            <Modal open={isOpen} onClose={handleCloseModal} className={styles.modal}>
                <Typography variant="h4">{t('auth.logout.label')}</Typography>
                <div className={styles.actions}>
                    <Button onClick={handleCloseModal} color="gray">
                        {t('auth.logout.cancel')}
                    </Button>
                    <Button onClick={handleLogout}>{t('auth.logout.approve')}</Button>
                </div>
            </Modal>
        </>
    );
};
